module.exports = require('resolve-url');
